<template>
  <v-form>
    <v-row dense>
      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.CustomerId"
          :items="customers"
          label="Customer"
          item-text="Name"
          item-value="id"
          :search-input.sync="searchCustomers"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-text-field name="newStoreName" outlined dense label="Store / Branch Name" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.RegionId"
          :items="regions"
          label="Region"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          dense
          outlined
          v-model="record.SalesRepId"
          :items="users"
          label="Sales Rep"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          autocomplete="off"
          name="customerPriceList"
          hide-details
          dense
          outlined
          v-model="record.priceListId"
          :items="priceLists"
          label="Price List"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>


      <v-col cols="3">
        <v-text-field type="number"  outlined dense label="Monthly Sales Target" v-model="monthlySalesTarget"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="primary"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "StoresIndex",
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    loader: false,
    searchCustomers: null,
    monthlySalesTarget: null,
    priceLists: [],
    customers: [],
    regions: [],
    users: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      this.record.StrType = 1;
      var monthlySalesTarget = parseFloat(this.monthlySalesTarget) ?? 0.0;
      this.record.monthlySalesTarget = monthlySalesTarget;
      this.record.DocDate = new Date().toISOString().substr(0, 10);
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRegions() {
      const self = this;
      this.$store
        .dispatch("get", `/region`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.regions = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getPriceLists() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getRegions(), this.getUsers(), this.getPriceLists()]);
  }
};
</script>